<div id="floatContainer" class="container {{inputState}} pr-0" [ngClass]="style">
  <label>
    <span for="floatField">{{ label }}</span>
    <input id="{{ id ? id + 'Input' : 'floatField' }}" type="{{ type }}" [(ngModel)]="value" validatePassGeneration (setLevel)="getState($event)" (level)="setLevel($event)"
      (ngModelChange)="updateChanges()" (focus)="onFocus()" (focusout)="onFocusOut()" autocomplete="off" onPaste="return false"
      onCopy="return false" [minLength]="minLength" [maxLength]="maxLength" (keydown)="validateSpecialCharacter($event)">
    <div class="icon">
      <img [src]="visiblePass ? eyeSlashIcon : eyeIcon" alt="icon" id="idEye" (click)="togglePassword()">
      <img [src]="checkIcon" alt="icon" *ngIf="isValid">
    </div>
  </label>
</div>
<p *ngIf="!isRulesOk" class="message-error" id="errorMessage">{{labelError}}</p>
<progress-bar-pass [level]="level" id="SecurityLevel" *ngIf="isLevel" ></progress-bar-pass>
<div *ngIf="isValidators">
  <p id="lbl_pass_length">
    <img [src]="xIcon" alt="icon" id="lbl_pass_length_error" *ngIf="!state.length">
    <img [src]="checkIcon" alt="icon" id="lbl_pass_length_ok" *ngIf="state.length">
    {{lengthValidationMessage}}</p>
  <p id="lbl_pass_length">
     <img [src]="xIcon" alt="icon" id="lbl_pass_length_error" *ngIf="!state.upper || !state.lower">
     <img [src]="checkIcon"  alt="icon" id="lbl_pass_length_ok" *ngIf="state.upper && state.lower">
     {{validationUpperAndLower}}</p>
  <p id="lbl_pass_number">
    <img [src]="xIcon" alt="icon" id="lbl_pass_number_error" *ngIf="!state.number">
    <img [src]="checkIcon"  alt="icon" id="lbl_pass_number_ok" *ngIf="state.number">
    {{letterAndNumberValidationMessage}}</p>
  <p id="lbl_pass_username">
    <img [src]="xIcon" alt="icon" id="lbl_pass_username_error" *ngIf="!state.username">
    <img [src]="checkIcon"  alt="icon" id="lbl_pass_username_ok" *ngIf="state.username">
    {{doNotMatchUserNameMessage}}</p>

    <p id="lbl_pass_username_contains" *ngIf="validateContainUsernameMessaje != ''">
      <img [src]="xIcon" alt="icon" id="lbl_pass_username_contains_error" *ngIf="!state.usernameContains">
      <img [src]="checkIcon"  alt="icon" id="lbl_pass_username_contains_ok" *ngIf="state.usernameContains">
      {{validateContainUsernameMessaje}}</p>

  <p id="lbl_pass_special">
    <img [src]="xIcon" alt="icon" id="lbl_pass_special_error" *ngIf="!state.special">
    <img [src]="checkIcon"  alt="icon" id="lbl_pass_special_ok" *ngIf="state.special">
    {{specialCharacterMessage}}</p>
</div>
<br>
<div id="floatContainerConfirm" class="container pr-0 {{inputStateConfirm}}" [ngClass]="styleConfirm">
  <label>
    <span for="floatFieldConfirm">{{ labelConfirm }}</span>
    <input id="{{ id ? id + 'InputConfirm' : 'floatFieldConfirm' }}" [disabled]="(inputStateConfirm == 'disabled')" type="{{ typeConfirm }}" [(ngModel)]="valueConfirm"
      (input)="ifIsEquals()" validatePassGeneration (focus)="onFocusConfirm()" (focusout)="onFocusOutConfirm()"
      autocomplete="off" onPaste="return false" onCopy="return false" [minLength]="minLength" [maxLength]="maxLength" >
    <div class="icon">
      <img [src]="visiblePassConfirm ? eyeSlashIcon : eyeIcon" alt="icon" id="idEye" (click)="togglePassWordConfirm()">
      <img [src]="checkIcon" alt="icon" id="idEyeConfirm" *ngIf="!isEquals">
      <img [src]="xIcon" alt="icon" id="idEyeConfirm" *ngIf="isEquals" (click)="clearConfirmPassword()">
    </div>
  </label>

</div>
<p *ngIf="isEquals" class="message-error" id="{{ id ? id + 'Message' : 'errorMessageConfirm' }}">
  {{ labelErrorConfirm }}
</p>
